import React from 'react';
import { MessageCircle } from 'lucide-react';
import './ConversationList.css';

const ConversationList = ({ conversations, selectedId, onSelect, loading }) => {
  const getInitials = (name) => {
    if (!name) return '??';
    return name
      .split(' ')
      .map((w) => w[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const formatRelativeTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Maintenant';
    if (diffMins < 60) return `${diffMins} min`;
    if (diffHours < 24) return `${diffHours} h`;
    if (diffDays < 7) return `${diffDays} j`;
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
  };

  if (loading) {
    return (
      <div className="conv-list-loading">
        <div className="conv-spinner" />
        <p>Chargement…</p>
      </div>
    );
  }

  if (conversations.length === 0) {
    return (
      <div className="conv-list-empty">
        <div className="conv-list-empty-icon">
          <MessageCircle size={28} strokeWidth={1.8} />
        </div>
        <p>Aucune conversation</p>
        <small>Réservez un salon pour démarrer une conversation</small>
      </div>
    );
  }

  return (
    <div className="conv-list">
      {conversations.map((conv) => (
        <button
          key={conv.id}
          type="button"
          className={`conv-item ${selectedId === conv.id ? 'active' : ''}`}
          onClick={() => onSelect(conv)}
        >
          <div className="conv-avatar">
            {conv.salon_profile_image ? (
              <img src={conv.salon_profile_image} alt="" />
            ) : (
              <span>{getInitials(conv.salon_name)}</span>
            )}
          </div>
          <div className="conv-info">
            <div className="conv-top">
              <span className="conv-name">{conv.salon_name}</span>
              <span className="conv-time">{formatRelativeTime(conv.last_message_at)}</span>
            </div>
            <div className="conv-bottom">
              <p className={`conv-preview ${conv.unread_count > 0 ? 'unread' : ''}`}>
                {conv.last_message || 'Nouvelle conversation'}
              </p>
              {conv.unread_count > 0 && (
                <span className="conv-badge">
                  {conv.unread_count > 99 ? '99+' : conv.unread_count}
                </span>
              )}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default ConversationList;
